import React, {FC, memo} from "react";
import moment from "moment";
import css from "./TableDatePicker.less";
import {ISODateString} from "../../helpers/typeScriptHelpers";
import DateInput, {DateInputProps} from "../DateInput/DateInput";

type TableDatePickerProps = DateInputProps & {
    defaultDate?: ISODateString;
};
const TableDatePicker: FC<TableDatePickerProps> = ({defaultDate = new Date().toISOString(), ...restProps}) => (
    <DateInput
        className={css.root}
        defaultValue={moment(defaultDate)}
        size="small"
        displayFormat="dd DD.MM.YY"
        allowClear={false}
        {...restProps}
    />
);

export default memo(TableDatePicker);
